var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "messageBox sub-main"
    },
    [
      _vm.flag
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "messageList" },
                _vm._l(_vm.messageList, function(item) {
                  return _c(
                    "div",
                    { key: item.noticeId, staticClass: "itemBox" },
                    [
                      _c("div", {
                        staticClass: "icon iconfont",
                        class: { color: item.noticeType === 3 },
                        domProps: {
                          innerHTML: _vm._s(
                            item.noticeType === 1 ? "&#xe64a;" : "&#xe647;"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "messageTitle" }, [
                        item.noticeType === 1
                          ? _c(
                              "h3",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.goToDetail(item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.noticeContent))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.noticeType === 3
                          ? _c(
                              "h3",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.goToDetail(item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.noticeTitle))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.createTime))])
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.messageList.length
                ? _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager, next, jumper",
                      "page-size": _vm.pageSize,
                      "current-page": _vm.page,
                      total: _vm.total
                    },
                    on: { "current-change": _vm.handleCurrentChange }
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "nothing" },
            [
              _c("img", {
                attrs: {
                  src: require("../../../../static/image/noorder@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "fs20 font-color-999" }, [
                _vm._v("您还没有消息～")
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: "/" } },
                [_c("el-button", [_vm._v("去首页看看")])],
                1
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-b7894e02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-b7894e02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/messageCenter/message.vue
// module id = null
// module chunks = 